import { render } from "./EDITCardUPINCXilema.vue?vue&type=template&id=baaaeaa8&scoped=true"
import script from "./EDITCardUPINCXilema.vue?vue&type=script&lang=js"
export * from "./EDITCardUPINCXilema.vue?vue&type=script&lang=js"

import "./EDITCardUPINCXilema.vue?vue&type=style&index=0&id=baaaeaa8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baaaeaa8"]])

export default __exports__